module.exports = __webpack_public_path__ + "static/media/facebook.2b3ecf8d.png";